export default "__VITE_ASSET__bd8dab5e__"